export default [
    {
        path: "/admin/monthly-incentive-bonus",
        name: "monthly-incentive-bonus",
        meta: { requiresAuth: true },
        component: () => import("@/pages/payroll/monthly-incentive-bonus/index.vue")
    }
];